import React from "react";
import { noop } from "lodash";
import { bool, func, string } from "prop-types";

import * as S from "./styled";

const DrawerFormButtons = ({
  cancelText,
  hasCancelOnMobile,
  isSubmitting,
  onCancel,
  onClickSubmit,
  submitText
}) => (
  <S.SubmitButtonContainer $hasCancelOnMobile={hasCancelOnMobile}>
    <S.CancelButton
      $hasCancelOnMobile={hasCancelOnMobile}
      minWidth
      onClick={onCancel}
      theme="hollow"
      type="button"
    >
      {cancelText}
    </S.CancelButton>
    <S.SubmitButton
      disabled={isSubmitting}
      onClick={onClickSubmit}
      theme="primary"
      type="submit"
    >
      {submitText}
    </S.SubmitButton>
  </S.SubmitButtonContainer>
);

DrawerFormButtons.propTypes = {
  cancelText: string,
  hasCancelOnMobile: bool,
  isSubmitting: bool,
  onCancel: func,
  onClickSubmit: func,
  submitText: string
};

DrawerFormButtons.defaultProps = {
  cancelText: "Cancel",
  hasCancelOnMobile: false,
  isSubmitting: false,
  onCancel: noop,
  onClickSubmit: noop,
  submitText: "Submit"
};

export default DrawerFormButtons;
